export enum AppType {
  App = 'APP',
  Bundle = 'BUNDLE',
}
